export const sd = {
	// spiel: [
	// 	'v01c0', 'v01k0', 'v01p1', 'v01t1', 'v02c0', 'v02k0', 'v02p1', 'v02t1', 'v03c0', 'v03k0', 'v03p1', 'v03t1', 
	// 	'v04c0', 'v04k0', 'v04p1', 'v04t1', 'v05c0', 'v05k0', 'v05p1', 'v05t1', 'v06c0', 'v06k0', 'v06p1', 'v06t1', 
	// 	'v07c0', 'v07k0', 'v07p1', 'v07t1', 'v08c0', 'v08k0', 'v08p1', 'v08t1', 'v09c0', 'v09k0', 'v09p1', 'v09t1', 
	// 	'v10c0', 'v10k0', 'v10p1', 'v10t1', 'v12c0', 'v12k0', 'v12p1', 'v12t1', 'v13c0', 'v13k0', 'v13p1', 'v13t1', 
	// 	'v14c0', 'v14k0', 'v14p1', 'v14t1', 
	// 	'v01c0', 'v01k0', 'v01p1', 'v01t1', 'v02c0', 'v02k0', 'v02p1', 'v02t1', 'v03c0', 'v03k0', 'v03p1', 'v03t1', 
	// 	'v04c0', 'v04k0', 'v04p1', 'v04t1', 'v05c0', 'v05k0', 'v05p1', 'v05t1', 'v06c0', 'v06k0', 'v06p1', 'v06t1', 
	// 	'v07c0', 'v07k0', 'v07p1', 'v07t1', 'v08c0', 'v08k0', 'v08p1', 'v08t1', 'v09c0', 'v09k0', 'v09p1', 'v09t1', 
	// 	'v10c0', 'v10k0', 'v10p1', 'v10t1', 'v12c0', 'v12k0', 'v12p1', 'v12t1', 'v13c0', 'v13k0', 'v13p1', 'v13t1', 
	// 	'v14c0', 'v14k0', 'v14p1', 'v14t1', 
	// ],
	spiel: [
		'v01t1','v02t1','v03t1','v04t1','v05t1','v06t1','v07t1','v08t1','v09t1','v10t1','v12t1','v13t1','v14t1',
		'v01t1','v02t1','v03t1','v04t1','v05t1','v06t1','v07t1','v08t1','v09t1','v10t1','v12t1','v13t1','v14t1',
		'v01c0','v02c0','v03c0','v04c0','v05c0','v06c0','v07c0','v08c0','v09c0','v10c0','v12c0','v13c0','v14c0',
		'v01c0','v02c0','v03c0','v04c0','v05c0','v06c0','v07c0','v08c0','v09c0','v10c0','v12c0','v13c0','v14c0',
		'v01p1','v02p1','v03p1','v04p1','v05p1','v06p1','v07p1','v08p1','v09p1','v10p1','v12p1','v13p1','v14p1',
		'v01p1','v02p1','v03p1','v04p1','v05p1','v06p1','v07p1','v08p1','v09p1','v10p1','v12p1','v13p1','v14p1',
		'v01k0','v02k0','v03k0','v04k0','v05k0','v06k0','v07k0','v08k0','v09k0','v10k0','v12k0','v13k0','v14k0',
		'v01k0','v02k0','v03k0','v04k0','v05k0','v06k0','v07k0','v08k0','v09k0','v10k0','v12k0','v13k0','v14k0',
	],
	zuege: null,
	idx: 0,
	folge: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '12', '13', '14'],
	bewegungen: [],
	init(feld, stappel, ablage) {
		this.feld = feld;
		this.stappel = stappel;
		this.ablage = ablage;
	},
	idxFrei(feld, c_idx) {
		let r_idx = feld.value.findIndex(row => row[c_idx] === '');
		if (r_idx === -1) {
			r_idx =feld.value.length;
			feld.value.push(['', '', '', '', '', '', '', '', ''])
		}
		return r_idx;
	},
	idxFolge(karte) {
		return this.folge.findIndex(f => f === karte.replace(/v/g, '').substring(0,2));
	},
	insZug(von, zu) {
		if (!this.zuege) {
			this.zuege = [];
		}
		if ( this.zuege.length > this.idx ) {
			this.zuege.splice(this.idx + 1);
		}
		this.idx = this.zuege.length;
		this.zuege.push([{ von, zu }]);
		// console.log('* insZug', this.idx, JSON.parse(JSON.stringify(this.zuege)));
	},
	addZug(von, zu) {
		this.zuege[this.idx].unshift({von, zu});
		// console.log('+ addZug', JSON.parse(JSON.stringify(this.zuege[this.idx])));
	},
	anzeigeKart(karte) {
		if (!karte) {
			return '';
		} if (karte.charAt(0) === 'v') {
			return karte.substring(1);
		}
		return karte;
	},
	undoZug() {
		if (this.idx >= 0) {
			this.bewegungen = [];
			const zuege = JSON.parse(JSON.stringify(this.zuege[this.idx]));
			let zug = zuege.shift();
			while (zug) {
				if (zug.von.stappel) {
					this.stappel.value.unshift(zug.zu.karte);
					this.bewegungen.push({r_idx:zug.zu.r_idx, c_idx:zug.zu.c_idx, karte: ''});
				} else if (zug.von.verso) {
					this.feld.value[zug.zu.r_idx][zug.zu.c_idx] = 'v' + this.anzeigeKart(zug.zu.karte);
				} else if (zug.von.a_idx != undefined) {
					this.ablage.value[zug.von.a_idx].unshift(this.anzeigeKart(zug.zu.karte));
					this.feld.value[zug.zu.r_idx][zug.zu.c_idx] = '';
				} else if (zug.zu.a_idx != undefined) {
					this.ablage.value[zug.zu.a_idx].shift();
					this.feld.value[zug.von.r_idx][zug.von.c_idx] = this.anzeigeKart(zug.von.karte);
				} else {
					this.feld.value[zug.von.r_idx][zug.von.c_idx] = this.anzeigeKart(zug.zu.karte);
					this.feld.value[zug.zu.r_idx][zug.zu.c_idx] = this.anzeigeKart(zug.von.karte);
				}
				zug = zuege.shift();
			}
			this.idx--;
			if (this.bewegungen.length) {
				this.bewegen();
			}
		}
	},
	redoZug() {
		if (this.idx < this.zuege.length - 1) {
			this.bewegungen = [];
			this.idx++;
			const zuege = JSON.parse(JSON.stringify(this.zuege[this.idx]));
			let zug = zuege.pop();
			while (zug) {
				if (zug.von.stappel) {
					this.stappel.value.shift();
					this.bewegungen.unshift({r_idx:zug.zu.r_idx, c_idx:zug.zu.c_idx, karte: this.anzeigeKart(zug.zu.karte)});
				} else if (zug.von.verso) {
					this.feld.value[zug.zu.r_idx][zug.zu.c_idx] = this.anzeigeKart(zug.zu.karte);
				} else if (zug.von.a_idx != undefined) {
					this.ablage.value[zug.von.a_idx].shift();
					this.feld.value[zug.zu.r_idx][zug.zu.c_idx] = this.anzeigeKart(zug.zu.karte);
				} else if (zug.zu.a_idx != undefined) {
					this.ablage.value[zug.zu.a_idx].unshift(this.anzeigeKart(zug.von.karte));
					this.feld.value[zug.von.r_idx][zug.von.c_idx] = '';
				} else {
					this.feld.value[zug.von.r_idx][zug.von.c_idx] = this.anzeigeKart(zug.zu.karte);
					this.feld.value[zug.zu.r_idx][zug.zu.c_idx] = this.anzeigeKart(zug.von.karte);
				}
				zug = zuege.pop();
			}
			if (this.bewegungen.length) {
				this.bewegen();
			}
		}
	},
	zeigeVerso(feld, r_idx, c_idx) {
		if (r_idx >= 0 && feld.value[r_idx][c_idx].charAt(0) === 'v' ) {
			const karte = feld.value[r_idx][c_idx];
			feld.value[r_idx][c_idx] = this.anzeigeKart(karte);
			this.addZug({verso: true}, {karte, r_idx, c_idx});
		}
	},
	istParent(pKarte, cKarte) {
		return this.idxFolge(pKarte) === this.idxFolge(cKarte) + 1 && (cKarte.charAt(3) % 2 !== pKarte.charAt(3) % 2);
	},
	gruppe(feld, r_idx, c_idx) {
		const result = [];
		if (feld.value[r_idx][c_idx] && feld.value[r_idx][c_idx].charAt(0) !== 'v') {
			let karte = feld.value[r_idx][c_idx];
			result.push({karte, r_idx, c_idx});
			r_idx++;
			while(r_idx < feld.value.length) {
				if (!feld.value[r_idx][c_idx]) {
					break;
				}
				const karte2 = feld.value[r_idx][c_idx];
				if (this.istParent(karte, karte2)) {
					karte = karte2;
					result.push({karte, r_idx, c_idx});
				} else {
					return null;
				}
				r_idx++;
			}
		}
		return result;
	},
	bewegen() {
		this.move();
	},
	move() {
		const b = this.bewegungen.shift();
		this.feld.value[b.r_idx][b.c_idx] = b.karte;
		if (this.bewegungen.length) {
			setTimeout(() => { this.move(); }, 20);
		}
	}
}